import React from 'react';

// types
import { IGeneralProjectsContextMenu } from '../../../types/studio.types';

const GeneralProjectsContextMenu = ({
  position,
  isVisible,
  handleAddNewFolder,
  onCreateBlankProject,
  isToolStudio,
}: IGeneralProjectsContextMenu) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        top: position.y,
        left: position.x,
      }}
      className={`context-menu ${
        !isToolStudio
          ? '!bg-[#fff] !text-[#212121] dark:!text-[#eee] dark:!bg-[#3b3b3b]'
          : ''
      }`}
    >
      <div
        className={`context-menu--option ${
          !isToolStudio ? 'hover:!bg-[#eee] dark:hover:!bg-[#212121]' : ''
        }`}
        id="general-context-menu-rename"
        onClick={() => onCreateBlankProject()}
      >
        <img
          src="/static/img/icons/white-plus.svg"
          alt="plus"
          className={`${!isToolStudio ? 'hidden dark:block' : ''}`}
        />
        {!isToolStudio && (
          <img
            src="/static/img/icons/bold-plus.svg"
            alt="plus"
            className="w-[14px] ml-1 h-[17px] block dark:hidden"
          />
        )}
        <span>Create new project</span>
      </div>

      <div
        className={`context-menu--option ${
          !isToolStudio ? 'hover:!bg-[#eee] dark:hover:!bg-[#212121]' : ''
        }`}
        id="general-context-menu-duplicate"
        onClick={() => handleAddNewFolder(true)}
      >
        <img
          src="/static/img/icons/create-new-folder.svg"
          alt="duplicate"
          className={`${!isToolStudio ? 'hidden dark:block' : ''}`}
        />
        {!isToolStudio && (
          <img
            src="/static/img/icons/create-new-folder-dark.svg"
            alt="duplicate"
            className="block dark:hidden"
          />
        )}
        <span>New Folder</span>
      </div>
    </div>
  );
};

export default GeneralProjectsContextMenu;
